export const API_URL = process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL : "http://10.0.0.105:8080";
export const ENV = process.env.REACT_APP_ENV ?? "dev";
export const MAX_CHARACTERS = 15;
export const MAX_PREVIEW_MB = 50;
